enum PillType {
  Beta = 'Beta',
}

export default PillType;
